export class EventFootnote {
  public index: number;
  public label: string;
}
